import _ from 'lodash';

export function mortgageNextButtonTrack(
  props, currentIndex, STEP_ENUM, MORTGAGE_STEPS, funnelData
) {
  const { track } = props;
  const trackingData = {};
  const finalSearchResultsTrackingData = {};
  const finalSearchResultsData = [];
  trackingData.event = 'filter';

  const {
    mortgageType,
    propertyType,
    propertyValue,
    borrowPercentage,
    loanTenure,
    loanAmount,
    incomeEarntHK,
  } = funnelData;

  switch (MORTGAGE_STEPS[currentIndex]) {
    case STEP_ENUM.MORTGAGE_TYPE:
      trackingData.mortgageType = mortgageType;
      break;
    case STEP_ENUM.PROPERTY_TYPE:
      trackingData.mortgagePropertyType = propertyType;
      break;
    case STEP_ENUM.LOAN_DETAIL:
      trackingData.mortgagePropertyValue = propertyValue;
      trackingData.mortgageBorrowPercentage = borrowPercentage;
      trackingData.mortgagePeriod = loanTenure;
      trackingData.mortgageAmount = loanAmount;
      break;
    case STEP_ENUM.INCOME_EARNT:
      trackingData.mortgageIncomeHK = incomeEarntHK;

      finalSearchResultsData.push(mortgageType);
      finalSearchResultsData.push(propertyType);
      finalSearchResultsData.push(propertyValue);
      finalSearchResultsData.push(borrowPercentage);
      finalSearchResultsData.push(loanTenure);
      finalSearchResultsData.push(loanAmount);
      finalSearchResultsData.push(incomeEarntHK);
      finalSearchResultsTrackingData.event = 'finalSearch';
      finalSearchResultsTrackingData.finalSearchResults = _.join(finalSearchResultsData, '|');
      break;
    default:
  }

  if (MORTGAGE_STEPS[currentIndex] !== STEP_ENUM.MORTGAGE_TYPE) {
    track({ data: trackingData });
    if (MORTGAGE_STEPS[currentIndex] === STEP_ENUM.INCOME_EARNT) {
      track({ data: finalSearchResultsTrackingData });
    }
  }
}

export function onTypeChangeTrack(props, data) {
  const { track } = props;
  track({ data });
}

export function travelInsuranceNextButtonTrack(props, currentIndex, steps, STEP_ENUM, funnelData) {
  const { track } = props;

  const {
    insuranceType,
    destinations,
    travellers,
    startDate,
    endDate,
    additionalCoverages,
    region,
  } = funnelData;
  const trackingData = {};
  const finalSearchResultsTrackingData = {};
  const finalSearchResultsData = [];
  trackingData.event = 'filter';
  switch (steps[currentIndex]) {
    case STEP_ENUM.INSURANCE_TYPE:
      break;
    case STEP_ENUM.DESTINATIONS:
      trackingData.travelDestination = destinations.join(',');
      break;
    case STEP_ENUM.TRAVELLERS:
      trackingData.travelDOB = travellers.map(traveller => traveller.dateOfBirth).join(',');
      trackingData.travelRelationship = travellers.map(traveller => traveller.relationship).join(',');
      break;
    case STEP_ENUM.START_DATE_AND_END_DATE:
      trackingData.travelFirstDate = startDate;
      trackingData.travelSecondDate = endDate;
      break;
    case STEP_ENUM.START_DATE:
      trackingData.travelFirstDate = startDate;
      break;
    case STEP_ENUM.COVERAGES:
      trackingData.travelExtras = additionalCoverages.join(',');
      finalSearchResultsData.push(insuranceType || '');
      finalSearchResultsData.push(destinations.join(','));
      finalSearchResultsData.push(travellers.map(traveller => traveller.dateOfBirth).join(','));
      finalSearchResultsData.push(travellers.map(traveller => traveller.relationship).join(','));
      finalSearchResultsData.push(startDate);
      finalSearchResultsData.push(endDate);
      finalSearchResultsData.push(additionalCoverages.join(','));
      finalSearchResultsData.push(region || '');
      finalSearchResultsTrackingData.event = 'finalSearch';
      finalSearchResultsTrackingData.finalSearchResults = finalSearchResultsData.join('|');
      break;
    default:
  }
  if (steps[currentIndex] !== STEP_ENUM.INSURANCE_TYPE) {
    track({ data: trackingData });
    if (steps[currentIndex] === STEP_ENUM.COVERAGES) {
      track({ data: finalSearchResultsTrackingData });
    }
  }
}
